import template from './dashboard-printable-report.component.html';
import type { Orientation } from '../../Print/export-dialog/export-dialog.component';
import type { DashboardFiltersValues } from '../dashboard-filters.service';
import type { ThemeService } from '../../Theme/mx-theme.service';
import type { PrintingService } from '../../Print/printing.service';
import type { IAugmentedJQuery } from 'angular';
import type { ThemeConfig } from '../../Theme/mx-theme.directive';
import type { HttpService } from '../../App/services/http-service';

export class DashboardPrintableReportController {
	navigationId?: string;
	filters: DashboardFiltersValues = {};
	orientation: Orientation = 'portrait';
	themeId?: string;
	isContrastTheme: boolean = false;
	includeHeaderFooter: boolean = false;
	headerTitle = '';

	printingHeader?: string;
	printingFooter?: string;
	themeConfig?: ThemeConfig;

	static readonly $inject = ['$element', 'mx.app.ThemeService', 'mx.sb.Printing.PrintingService', 'mx.shell.Http'];
	constructor(
		private readonly $element: IAugmentedJQuery,
		private readonly themeService: ThemeService,
		private readonly printingService: PrintingService,
		private readonly httpService: HttpService
	) {}

	async $onInit() {
		const theme = this.themeId ? await this.themeService.getTheme(this.themeId, this.isContrastTheme) : await this.themeService.getCurrentTheme(this.isContrastTheme);

		if (this.includeHeaderFooter) {
			const { printingHeader, printingFooter } = (await this.printingService.getCurrentApplicationPrintingMarkup(this.headerTitle, theme['applicationLogoUrl'])) || {};
			this.printingFooter = printingFooter;
			this.printingHeader = printingHeader;
		}
		this.themeConfig = {
			themeId: theme.id,
			isContrastTheme: theme.isContrastTheme,
		};
	}

	async onReportLoaded() {
		await this.httpService.waitForAllRequests();
		await new Promise((resolve) => setTimeout(resolve, 500));

		const headerNode = this.$element.find('#report-header')[0];
		const footerNode = this.$element.find('#report-footer')[0];
		const contentNode = this.$element.find('#report-content')[0];

		await this.printingService.prepareNodeForPrinting(
			{
				type: 'pdf',
				width: 0,
				headerNode,
				footerNode,
				contentNode,
				orientation: this.orientation,
				themeId: this.themeId,
				isContrastTheme: this.isContrastTheme,
			},
			false
		);
	}
}

export const DashboardPrintableReportComponent = {
	name: 'mxDashboardPrintableReport',
	bindings: {
		navigationId: '<',
		headerTitle: '<',
		filters: '<',
		orientation: '<',
		includeHeaderFooter: '<',
		themeId: '<',
		isContrastTheme: '<',
	},
	controller: DashboardPrintableReportController,
	controllerAs: 'vm',
	template,
};
